/**
 * @file GraphQL device API
 */

import { CashLocation, DeviceInfo } from "@/types/gql/device";
import {
  Get_DeviceLocationQuery,
  Get_DeviceLocationQueryVariables,
  Get_GroupCashLocationsQuery,
  Get_GroupCashLocationsQueryVariables,
  Get_GroupDevicesQuery,
  Get_GroupDevicesQueryVariables,
  Get_LastCashFloatQuery,
  Get_LastCashFloatQueryVariables,
  // GET_DeviceLocationQuery,
  // GET_DeviceLocationQueryVariables
} from "@/types/gql/generated/graphql";
import { apolloClient } from "@/utils/graphql-client";
import {
  GET_GroupDevices,
  GET_GroupCashLocations,
  GET_DeviceLocation,
  GET_LastCashFloat,
} from "./queries/device.graphql";

/**
 * Fetches group devices using group id
 *
 * @param groupDevices groupId query
 */
export async function getGroupFreeDevices(groupId: number) {
  const res = await apolloClient.query<
    Get_GroupDevicesQuery,
    Get_GroupDevicesQueryVariables
  >({
    query: GET_GroupDevices,
    variables: { groupDevices: `(group_id,in,${groupId})~and(status,in,0)` },
  });

  const devices = res.data.devices;
  if (!devices) {
    throw new Error("No devices found");
  }
  return devices as DeviceInfo[];
}

/**
 * Fetch location attached to the device by its hardware uuid
 *
 */
export async function getDeviceLocation(hardwareUuid: string, groupId: number) {
  const res = await apolloClient.query<
    Get_DeviceLocationQuery,
    Get_DeviceLocationQueryVariables
  >({
    query: GET_DeviceLocation,
    variables: {
      condition: `(hardware_uid,in,${hardwareUuid})~and(status,in,1)~and(group_id,in,${groupId})`,
    },
  });

  const devices = res.data.devices;
  if (!devices) {
    throw new Error("No devices found");
  }
  return devices as DeviceInfo[];
}

/**
 * Fetches group cashLocations using group id
 *
 * @param groupId groupId
 */
export async function getGroupCashLocations(groupId: number) {
  const res = await apolloClient.query<
    Get_GroupCashLocationsQuery,
    Get_GroupCashLocationsQueryVariables
  >({
    query: GET_GroupCashLocations,
    variables: {
      groupLocations: `(group_id,in,${groupId})~and(canceled,in,0)`,
    },
  });

  const locations = res.data.cashLocations;
  if (!locations) {
    throw new Error("No location found");
  }
  return locations as CashLocation[];
}

/**
 * Fetches seqId of the last cashfloat
 */
export async function getLastCashFloat(deviceId: number) {
  const res = await apolloClient.query<
    Get_LastCashFloatQuery,
    Get_LastCashFloatQueryVariables
  >({
    query: GET_LastCashFloat,
    variables: { condition: `(device_id,eq,${deviceId})` },
  });

  const cashfloat = res.data.CashFloatList?.[0];
  if (!cashfloat) {
    throw new Error("No cashfloat found");
  }
  return cashfloat;
}
